export const generateScript = (state) => {
  let script = "";

  if (state.addPlaceholders) {
    script += `
    <script>
    var labels = document.querySelectorAll("div.pd-text label, div.pd-select label, div.pd-textarea label");
    var i = labels.length;
    while (i--) {
        var label = labels.item(i);
        var text = label.textContent;
        label.parentNode.classList.contains("required") && (text += "");
        var nextElement = label.nextElementSibling;
        if (nextElement) {
            if (nextElement.tagName == 'SELECT') {
                nextElement.options[0].text = text;
            } else {
                nextElement.setAttribute("placeholder", text);
            }
            ${
              state.removeFieldLabels 
              ? 'label.parentNode.removeChild(label);'
              : ''
            }
        }
    }
    </script>
      `;
  }

  // ... other script generation based on state

  return script;
};
